import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useActivityTracker } from '@/hooks/useActivityTracker';
import { useIframeController } from '@/hooks/useIframeController';
import { useServerActivityTracker } from '@/hooks/useServerActivityTracker';
import { integrationIdSelector, themeSelector } from '@/state/config';
/**
 * This class connects the socket with the events coming from the web-client
 */
export const IframeController = () => {
    const integrationId = useRecoilValue(integrationIdSelector);
    useIframeController();
    useActivityTracker(integrationId);
    useServerActivityTracker(integrationId);
    const theme = useRecoilValue(themeSelector);
    useEffect(() => {
        const htmlElement = document.documentElement;
        if (theme === 'dark') {
            htmlElement.classList.add('dark');
        }
        else {
            htmlElement.classList.remove('dark');
        }
    }, [theme]);
    return null;
};
